<div class="alert alert-warning mb-0" *ngIf="show">
  <a [routerLink]="['/', 'price-lists']"><span translate
    >No default active price list</span> &nbsp;<i class="fa fa-arrow-right"></i></a
  >
</div>
